export const useSelectedPolicy = async () => {
  const { selectedPolicy, getPolicies, setSelectedPolicy } = usePolicyStore()

  if (!selectedPolicy.policyId) {
    const policies = await getPolicies()

    if (policies.length) {
      setSelectedPolicy(policies[0])
    }
  }

  return { policyId: selectedPolicy.policyId }
}
